import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/profile/main-logged-out/src/xing-id/cover-image/assets/premium_984.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')